import {
  ButtonFilterDataPayloadValueArray,
  ButtonFilterDataPayloadValueBoolean,
  DashboardFilterName,
  DashboardFilterPayload,
  DashboardFilterType,
  DashboardFilterValues,
  DashboardPaidPackagesEnum,
  DashboardTypeActiveAnomalies,
} from '@vi-iot/client';

import { DashboardFilter, DashboardListFilterButtonData } from '@store';

export namespace KanbanBoardMappers {
  export function extractFiltersPayload(filters: DashboardFilter[]): DashboardFilterPayload {
    const output: DashboardFilterPayload = {};

    filters.forEach((filter) => {
      switch (filter.type) {
        case DashboardFilterType.Toggle:
          output[filter.filterName] = true;
          break;

        case DashboardFilterType.TextSearch:
          output[DashboardFilterName.Fulltext] = filter.value;
          break;

        case DashboardFilterType.Complex:
          let complexFilter = (output[filter.filterName] as DashboardFilterValues[]) ?? [];
          const filterValue = filter.value.toString() as DashboardFilterValues;
          output[filter.filterName] = [...complexFilter, filterValue];

          // Attach additional filter before sending request; don't modify selected filters in store
          if (
            filter.filterName === DashboardFilterName.ActiveAnomalies &&
            filterValue === 'warning'
          ) {
            const additionalFilters: DashboardTypeActiveAnomalies[] = ['critical', 'information'];
            output[filter.filterName] = [
              ...(output[filter.filterName] as DashboardFilterValues[]),
              ...additionalFilters,
            ];

            output[DashboardFilterName.PaidPackage]
              ? (output[DashboardFilterName.PaidPackage] = [
                  ...(output[DashboardFilterName.PaidPackage] as DashboardFilterValues[]),
                  ...[DashboardPaidPackagesEnum.Pro],
                ])
              : (output[DashboardFilterName.PaidPackage] = [DashboardPaidPackagesEnum.Pro]);
          }
          break;
      }
    });

    return output;
  }

  // I was unable to find a better solution, generic approach didn't catch invalid input during compilation
  export function getSumsPayloadDataArray(
    payload: ButtonFilterDataPayloadValueArray
  ): Pick<DashboardListFilterButtonData, 'filterName' | 'filterValue'> {
    const [filterNameAsString, filterValue] = Object.entries(payload)[0];
    const filterName = filterNameAsString as DashboardFilterName;

    return { filterName, filterValue };
  }

  export function getSumsPayloadDataBoolean(
    payload: ButtonFilterDataPayloadValueBoolean
  ): Pick<DashboardListFilterButtonData, 'filterName' | 'filterValue'> {
    const [filterNameAsString, filterValue] = Object.entries(payload)[0];
    const filterName = filterNameAsString as DashboardFilterName;

    return { filterName, filterValue };
  }
}
